import React from "react";
import { Helmet } from "react-helmet";
import { useFirmConfig } from "../context/firm-config-context";

const DynamicPageMeta = () => {
  const { firmConfig } = useFirmConfig();
  const firmName = firmConfig.firm_name || "Abundo Wealth";
  const descriptionFirm = firmConfig.firm_name || "Abundo";

  return (
    <Helmet>
      <title>{`${firmName} | Advice-Only Financial Planning`}</title>
      <meta
        name="description"
        content={`${descriptionFirm} provides ongoing, Advice-Only comprehensive financial planning at a low cost and without conflicts of interest.`}
      />
    </Helmet>
  );
};

export default DynamicPageMeta;
